"use client";

import React from "react";

import {
  LockCircle as ReactLockCircle,
  LockFlatTop as ReactLockFlatTop,
  LockRoundBottom as ReactLockRoundBottom,
  LockRoundedSquare as ReactLockRoundedSquare,
  LockSquare as ReactLockSquare,
} from "../deprecated/Lock";
import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const FoundationLock = createSVGIcon(
  <>
    <path
      d="M3.429 9.429h17.143v13.714H3.429zM18 9.428V6.857a6 6 0 1 0-12 0v2.571"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.143 16.286a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0Z"
      stroke="currentcolor"
      fill="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Lock",
  { viewBox: "0 0 24 24", titleAccess: "Lock", fill: "none" }
);

export const LockSquare = ReactLockSquare;
export const LockCircle = ReactLockCircle;
export const LockRoundBottom = ReactLockRoundBottom;
export const LockFlatTop = ReactLockFlatTop;
export const LockRoundedSquare = ReactLockRoundedSquare;

type LockType =
  | "square"
  | "circle"
  | "roundBottom"
  | "flat"
  | "roundedSquare"
  | "foundation";

/**
 * TODO (jfangrad): Replace with just single foundation lock icon
 * @trackcomponent
 */
export const Lock = React.memo(
  ({
    lockType,
    ref,
    ...props
  }: SVGIcon.IProps & {
    lockType: LockType;
  } & React.RefAttributes<SVGElement>) => {
    let SelectedLock = LockSquare;
    switch (lockType) {
      case "circle":
        SelectedLock = LockCircle;
        break;
      case "foundation":
        SelectedLock = FoundationLock;
        break;
      case "roundBottom":
        SelectedLock = LockRoundBottom;
        break;
      case "flat":
        SelectedLock = LockFlatTop;
        break;
      case "roundedSquare":
        SelectedLock = LockRoundedSquare;
        break;
      case "square":
      default:
        break;
    }
    return <SelectedLock ref={ref} {...props} />;
  }
);
